import React, { useEffect, useState } from 'react';
import UploadSignatureFile from './UploadSignatureFile';
import moment from "moment";
import SignaturePadComponent from './SignaturePadComponent';
import { useFormik } from 'formik';
import { fetchWithRetry } from '../../utils/fetchWithRetry';
const DigitalSignatureComponent = ({setErrorWhileUpload, errorWhileUpload= false, isAssessmentReview=null, signaturePadRef,fileInputRef,formik,readOnly,readOnlyData,setIsSig,ipAddress,setIpAddress,cDate,setCDate,isCancel,setSigType,from = null, removeSignature, loading,initialComp = 0}) => {
  const [signatureType, setSignatureType] = useState(from == 'quiz' && !readOnly ? initialComp : readOnly ? 1 : 0);
  const [fetchDateNIp, setFetchDateNIp] = useState(false);

  useEffect(() => {
    if(setSigType){
        setSigType(signatureType)
    }
  },[signatureType])

  useEffect(()=>{
    if(typeof setErrorWhileUpload === 'function' && errorWhileUpload){
      setFetchDateNIp(false)
      setErrorWhileUpload(false)
    }
  },[errorWhileUpload])


  useEffect(() => {
    if (!fetchDateNIp || readOnly) {
      return;
    }

    const controller = new AbortController();

    fetchWithRetry(
      'https://api.ipify.org?format=json',
      (data) => {
        if (data?.ip) {
          setIpAddress(data.ip);
          formik && formik.setFieldValue('ip', data.ip);
        }
      },
      { signal: controller.signal }
    );

    const now = new Date();
    setCDate(moment(now).format('DD MMM YYYY, HH:mm'));
    if (formik) {
      formik.setFieldValue('signature_date', now.getTime());
    }

    return () => controller.abort();
  }, [fetchDateNIp, readOnly]);

  useEffect(() => {
      setSignatureType(from == 'quiz' && !readOnly ? initialComp : readOnly ? 1 : 0)
  },[readOnly,from,initialComp])
  
    return (
      readOnly && (!isAssessmentReview && (from == 'quiz' ? !readOnlyData?.signature : !readOnlyData?.student_signature)) ? null :
        <div className='mb-3'>
            <div className="mt-3 mb-1">Signature*</div>
                <div className={`${readOnly ? 'd-none' : 'd-flex'} gap-2 mb-1 py-1`}>
                  <div className="border-b-black" style={{borderBottom : signatureType == 0 ? '1px #467FCF solid' : '0',color : signatureType == 0 ? '#467FCF' : fetchDateNIp || readOnly ? 'gray' : 'black',cursor: readOnly ? "" : 'pointer'}} onClick={() => {!fetchDateNIp && !readOnly && setSignatureType(0)}}>
                    <i className="fal fa-signature"></i>
                    <span className="ml-1">Draw</span>
                  </div>
                  <div className="border-b-black" style={{borderBottom : signatureType == 1 ? '1px #467FCF solid' : '0',color : signatureType == 1 ? '#467FCF' : fetchDateNIp || readOnly ? 'gray' : 'black',cursor: readOnly ? "" : 'pointer'}} onClick={() => {!fetchDateNIp && !readOnly && setSignatureType(1)}}>
                    <i className="fal fa-image"></i>
                    <span className="ml-1">Upload Image </span>
                  </div>
                </div>
                {signatureType == 0 && (
                  <>
                    <SignaturePadComponent setIsSig={setIsSig} isCancel={isCancel} readOnly={readOnly} setShowIp={setFetchDateNIp} formik={formik} showIp={fetchDateNIp} signaturePadRef={signaturePadRef} from={from} loading={loading} readOnlyData={readOnlyData}/>
                    {/* <i className="fal fa-info fa-circle"></i> */}
                  </>
                )}
                {signatureType == 1 && 
                  <UploadSignatureFile setIsSig={setIsSig} isCancel={isCancel} readOnly={readOnly} readOnlyData={readOnlyData} setShowIp={setFetchDateNIp} formik={formik} showIp={fetchDateNIp} fileInputRef={fileInputRef} from={from} removeSignature={removeSignature} isAssessmentReview={isAssessmentReview}/>
                }
          {!isAssessmentReview && readOnly && from == 'quiz' && readOnlyData?.signature_type == 0 ?
            <div className={`sig-btns ${readOnly ? from == 'quiz' ? 'd-flex' : 'd-none' : 'd-flex'} my-3 flex-column flex-sm-row gap-2`}>
              <button className='btn btn-primary' disabled={true} >Save Signature</button>
              <button className='btn btn-danger' onClick={() => {removeSignature(0);setFetchDateNIp(false)}}>Remove Signature</button>
            </div> : null
                }
                <div className='mt-2'>
                <span><i className='fal fa-info-circle mr-1'></i><b>IP:</b> {readOnly ? from == 'quiz' ? readOnlyData?.signature_ip : readOnlyData?.ip : fetchDateNIp ? ipAddress : ""}</span>
                <span className='ml-2'><b>Date: </b>{readOnly ? from == 'quiz' ? readOnlyData?.signature_date : moment(parseInt(readOnlyData?.signature_date*1000))?.format('DD MMM YYYY, HH:mm') :fetchDateNIp ? cDate : ""}</span>
                </div>
                {formik?.touched?.student_signature && formik?.errors?.student_signature ? (
                    <div className="invalid-feedback d-block">
                      {formik.errors.student_signature}
                    </div>
                  ) : null}
        </div>
    );
}
export default DigitalSignatureComponent;